import React, { useRef } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { NtIcon } from './NotionUI';

/**
 * Campo di ricerca con lente e, finché c'è del testo, una x in fondo per cancellarlo
 * (rimette il cursore nel campo). `onChange` riceve direttamente il testo.
 */
function SearchBox({ value, onChange, placeholder, title, className = '' }) {
  const { t } = useLanguage();
  const inputRef = useRef(null);

  return (
    <label className={`tpl-search ${className}`.trim()} title={title}>
      <NtIcon name="search" />
      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={placeholder}
      />
      {value !== '' && (
        <button
          type="button"
          className="tpl-search-clear"
          title={t('common.clearSearch')}
          aria-label={t('common.clearSearch')}
          onClick={(e) => {
            e.preventDefault();
            onChange('');
            inputRef.current?.focus();
          }}
        >
          ×
        </button>
      )}
    </label>
  );
}

export default SearchBox;
